import AxiosHealthWellness from '../../services/healthWellness';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const SKIP_LIFF = process.env.REACT_APP_SKIP_LIFF === 'true';

// Use dev axios instance when LIFF is skipped (localhost dev)
const devAxios = axios.create({ timeout: 30000 });
devAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('devToken');
  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  }
  const customer = JSON.parse(sessionStorage.getItem('customer'));
  if (customer) {
    config.headers.account = customer.amwayNumber || '';
    config.headers.customer = customer.partyId || '';
  }
  return config;
});

const http = SKIP_LIFF ? devAxios : AxiosHealthWellness;

/**
 * Fetch assessment questions
 * GET /hwAssessment/hwassessmentQuestion
 */
export const fetchAssessmentQuestions = async (assessmentId) => {
  const customer = JSON.parse(sessionStorage.getItem('customer'));
  const customerId = customer?._id || '';
  const response = await http.get(
    `${API_URL}/hwAssessment/hwassessmentQuestion`,
    {
      params: {
        assessment_id: assessmentId,
        customer_id: customerId,
        assessmentsStatus: 'PENDING',
      },
    }
  );
  return response?.data?.data;
};

/**
 * Submit assessment answers
 * POST /hwAssessment/hwAnswer
 */
export const submitAssessmentAnswers = async ({ assessmentId, answers, answerId = '', status = 'DONE' }) => {
  const customer = JSON.parse(sessionStorage.getItem('customer'));
  const customerId = customer?._id || '';

  const totalScore = answers.reduce((sum, a) => sum + (a.score || 0), 0);

  const response = await http.post(
    `${API_URL}/hwAssessment/hwAnswer`,
    {
      customer_id: customerId,
      assessment_id: assessmentId,
      answer_id: answerId,
      assessmentsStatus: status,
      score: totalScore,
      weight: 0,
      height: 0,
      waist: 0,
      bmi: 0,
      answers: answers.map((a) => ({
        question_id: a.questionId,
        answer: [a.answerId],
      })),
    }
  );
  return response?.data;
};

/**
 * Fetch assessment result/score
 * GET /hwAssessment/hwAssessmentResult
 */
export const fetchAssessmentResult = async (assessmentId, answerId) => {
  const response = await http.get(
    `${API_URL}/hwAssessment/hwAssessmentResult`,
    {
      params: {
        assessment_id: assessmentId,
        answer_id: answerId,
      },
    }
  );
  return response?.data?.data;
};

/**
 * Fetch assessment history log
 * GET /hwAssessment/hwAssessmentHistory
 */
export const fetchAssessmentHistory = async (assessmentId) => {
  const customer = JSON.parse(sessionStorage.getItem('customer'));
  const customerId = customer?._id || '';
  const response = await http.get(
    `${API_URL}/hwAssessment/hwAssessmentHistory`,
    {
      params: {
        assessment_id: assessmentId,
        customer_id: customerId,
      },
    }
  );
  return response?.data?.data;
};

/**
 * Fetch assessment metadata
 * GET /hwAssessment/allHwAssessment
 */
export const fetchAssessmentMetadata = async (assessmentId) => {
  const response = await http.get(
    `${API_URL}/hwAssessment/allHwAssessment`,
    {
      params: {
        assessment_id: assessmentId,
      },
    }
  );
  return response?.data?.data?.[0];
};
